import type { ValidationSchema } from '@wix/editor-elements-corvid-utils';

export const validationSchema: ValidationSchema = {
  type: ['object'],
  properties: {
    text: { type: ['string'], required: ['true'] },
    maxLines: { type: ['integer'], minimum: 1 },
    readMoreActionData: {
      type: ['object'],
      properties: {
        link: { type: ['string'] },
        target: { type: ['string'] },
        readMoreButtonVisible: { type: ['boolean'] },
        readMoreButtonText: { type: ['string'], minLength: 1 },
        readLessButtonText: { type: ['string'], minLength: 1 },
        collapsed: { type: ['boolean'] },
      },
    },
  },
};

export const linkToContentSchema: ValidationSchema = {
  type: ['object'],
  properties: {
    link: { type: ['string'] },
    target: { type: ['string'] },
    readMoreButtonVisible: { type: ['boolean'] },
    readMoreButtonText: { type: ['string'], minLength: 1 },
  },
};

export const expandOnCurrentPageSchema: ValidationSchema = {
  type: ['object'],
  properties: {
    readMoreButtonText: { type: ['string'], minLength: 1 },
    readLessButtonText: { type: ['string'], minLength: 1 },
    collapsed: { type: ['boolean'] },
  },
};
